import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import {AuthGuard} from '../guards/auth.guard';
import {LoaderInterceptor} from '../interceptors/loader.interceptor';
import {AuthenticationInterceptor} from '../interceptors/authentication.interceptor';
import {XsrfInterceptor} from '../interceptors/xsrf.interceptor';

@NgModule({ declarations: [], imports: [CommonModule], providers: [
        AuthGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthenticationInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoaderInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: XsrfInterceptor,
            multi: true
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class CoreModule {
}
